/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type TimeAloneEnum = (typeof TimeAloneEnum)[keyof typeof TimeAloneEnum];

export const TimeAloneEnum = {
  '<2': '<2',
  '2-4': '2-4',
  '4-8': '4-8',
  '>8': '>8',
} as const;
